import React, {useState} from 'react';
import { connect } from 'react-redux';
import {
    getCountry, getIsFormValidating,
    stateError
} from "../../selectors";
import {
     SERVER_STATES,
} from "../../constants";
import {
    updateCountryAction
} from "../../reducers";

const useComponentDidMount = onMountHandler => {
    React.useEffect(() => {
        onMountHandler();
    }, []);
};

const stateToProps = state => ({
    stateError: stateError(state),
    country: getCountry(state),
    isFormValidating: getIsFormValidating(state),
});

const actionsToProps = dispatch => ({
    updateCountry: payload => dispatch(updateCountryAction(payload)),
});

const State = props => {

    const [stateOpen, setStateOpen ] = useState(false);

    useComponentDidMount(() => {
        if (SERVER_STATES != null && SERVER_STATES.length > 0) {
            props.updateCountry(SERVER_STATES[0]);
        }
    });

    const closeDropDown = (e) => {
        setStateOpen(false);
    }

    return (
        <div className={`form-row ${props.stateError && props.stateError !== 'success' ? 'error' : ''}`}>
            <label className="form-label" htmlFor="select-state">
                State <span className="asterisk">*</span>
            </label>

            <div id="select-state" onBlur={() => setStateOpen(false)} tabIndex="-4" className={stateOpen === true ? 'dd-menu dd-menu-open' : 'dd-menu'}>
                <span className="dd-menu--trigger" onClick={() => setStateOpen(!stateOpen)}>
                    {props.country}
                </span>

                <span className="dd-menu--caret" />

                <ul className="dd-menu__list" disabled={props.isFormValidating}>
                    {SERVER_STATES && SERVER_STATES.map(el => (
                        <li key={`dd-state-${el}`} className="dd-menu__list-item">
                            <a onClick={() => {
                                setStateOpen(false);
                                props.updateCountry(el);
                            }} className="dd-menu__list-link">
                                {el}
                            </a>
                        </li>
                    ))}
                </ul>
            </div>

            <p className="callout error p10 txt-l">
                {props.stateError}
            </p>
        </div>
    );
}

export default connect(
    stateToProps,
    actionsToProps
)(State);
